import mediaApi from 'src/apis/media'

export default {
  methods: {
    async getBlobUrl(url) {
      try {
        const { data } = await mediaApi.getBlobData(url)
        return URL.createObjectURL(data)
      } catch (err) {
        return url
      }
    },
  }
}
